import { Component, EventEmitter, Output, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  @Output() toggleSidebarEvent = new EventEmitter<void>();

  UserName: any;
  userRole: any;

  dropdownOpen = false;

  constructor(private router: Router) {}

  ngOnInit(): void {
    this.UserName = localStorage.getItem('userName');
    this.userRole = localStorage.getItem('userRole');
  }

  toggleSidebar(): void {
    this.toggleSidebarEvent.emit();
  }

  logout(): void {
    localStorage.clear();

    if (this.userRole === 'Applicant') {
      this.router.navigate(['/applicant-login']);
    } else if (this.userRole === 'Employee') {
      this.router.navigate(['/employee-login']);
    } else {
      this.router.navigate(['/login']);
    }
  }
}


// WEBPACK FOOTER //
// ./src/app/common/header/header.component.ts